/**
 * Diccionario ESPAÑOL -> INGLÉS. La clave es la cadena en español EXACTA que aparece en el código
 * (con `useT()` de `i18n.tsx`). Lo que no esté aquí cae al español, así que se puede ir completando
 * por componentes sin romper nada.
 *
 * Reglas: la clave es literal (mismos acentos, mayúsculas y signos); usa `{x}` para lo que se
 * interpola; NO traduzcas nombres propios (Keellabs, Aerodrome, Uniswap, símbolos de token).
 */
import { LANDING } from "./i18n-partes/landing";
import { AJUSTES } from "./i18n-partes/ajustes";
import { DASHBOARD } from "./i18n-partes/dashboard";
import { MODALES } from "./i18n-partes/modales";
import { DETALLE } from "./i18n-partes/detalle";
import { MISC } from "./i18n-partes/misc";
import { RESTO } from "./i18n-partes/resto";
import { TRANSPARENCIA } from "./i18n-partes/transparencia";

export const EN: Record<string, string> = {
  // Diccionarios por sección (generados por componente). El bloque "base" de abajo va
  // el último a propósito: son cadenas curadas de barra/navegación/comunes y deben ganar
  // ante cualquier colisión con los parciales.
  ...LANDING,
  ...AJUSTES,
  ...DASHBOARD,
  ...MODALES,
  ...DETALLE,
  ...MISC,
  ...RESTO,
  ...TRANSPARENCIA,

  // --- barra / navegación ---
  "Ir a la portada": "Go to home",
  "Mis piscinas": "My pools",
  "Tus piscinas": "Your pools",
  "Dashboard": "Dashboard",
  "Panel": "Dashboard",
  "Bridge y Swap": "Bridge & Swap",
  "Referidos": "Referrals",
  "Gobierno": "Governance",
  "Explorar pools": "Explore pools",
  "Tus inversiones": "Your investments",
  "Conectando…": "Connecting…",
  "Estado del protocolo en tiempo real": "Protocol status in real time",
  "Mover dinero entre cadenas": "Move funds across chains",
  "Ver todas las piscinas del protocolo": "See every pool in the protocol",
  "Publicar lógica nueva con el retardo del timelock": "Publish new logic with the timelock delay",

  // --- comunes ---
  "Conecta tu wallet": "Connect your wallet",
  "Conectar wallet": "Connect wallet",
  "Reintentar": "Retry",
  "← Volver": "← Back",
  "Volver": "Back",
  "Cargando…": "Loading…",
  "Confirmar": "Confirm",
  "Cancelar": "Cancel",
  "Guardar": "Save",
  "Cerrar": "Close",
  "Aceptar": "Accept",

  // --- tema / idioma (controles de la barra) ---
  "Tema claro": "Light theme",
  "Tema oscuro": "Dark theme",
  "Cambiar a tema claro": "Switch to light theme",
  "Cambiar a tema oscuro": "Switch to dark theme",
  "Idioma": "Language",
  "Español": "Spanish",
  "Inglés": "English",

  // --- dashboard: volumen ---
  "Capital depositado": "Capital deposited",
  "Volumen del protocolo": "Protocol volume",
  "Total que ha entrado a los vaults": "Total deposited into the vaults",

  // --- robot reajustando (fuera de rango) ---
  "El robot está reajustando tu rango…": "The robot is rebalancing your range…",
  "moviendo los precios a donde tu liquidez vuelve a cobrar":
    "moving the prices to where your liquidity earns again",
};
